<template>
  <section class="container">
    <transition
      name="fade"
      mode="out-in"
      tag="div"
    >
      <router-view :key="$route.path" />
    </transition>
  </section>
</template>
<script>
export default {
  name: 'ClientInvoices',
  data() {
    return {
      loading: 1,
    };
  },
  beforeMount() {
    this.$store.dispatch('invoices/setInvoicesItems')
      .finally(() => { setTimeout(() => { this.loading = 0 }, 600) });
  },
};
</script>
